import React, { useEffect } from "react";
import { useDataProvider } from "../../api/DataProvider";
import "../../styles/devices/mob_SignDialog.css";
import VideoCarousel from "../../api/VideoCarousel";
import Button from "@mui/material/Button";
import SendIcon from "@mui/icons-material/Send";
import { useTranslation } from "react-i18next";

import Paper from "@mui/material/Paper";
import { pDataProvider, pDB_user_roles } from "../../utils/parameters";

export default function DialogContentSign(props) {
  const { t } = useTranslation("global")

  const { dialogElements, dialogPosition, setDialogPosition, sendFeedback2Server, handlePushScreenCollaborator, isAdmin, isTask } = props;
  const { currentUserRole, json_data_glosses } = useDataProvider();

  // useEffect(() => {isAdmin
  //   console.log("🚀 ~ file: DialogContentSign.js:21 ~ DialogContentSign ~ isAdmin:", isAdmin)  
    
  // }, [isAdmin]);
  
  
  return (
    <>
      <div className='sig_SignModal_CarouselContainer'>
        <VideoCarousel dialogElements={dialogElements} dialogPosition={dialogPosition} setDialogPosition={setDialogPosition} isTask={isTask}/>
      </div>
      <div className="sig_SignModal_Sign">
        {dialogPosition["gloss"] !== undefined ? (
          <>
            <Paper className={`sig_SignModal_PaperContent ${ json_data_glosses[dialogPosition["gloss"]][pDataProvider.model]===true ? 'sig_SignModal_PaperDefined' : 'sig_SignModal_PaperUndefined' }`}>
              {/* <div className='sig_SignModal_PaperInfo'>
                <div className='sig_SignModal_PaperLine'>
                  { json_data_glosses[dialogPosition["gloss"]][pDataProvider.model]===true ? "Glosa disponible en la búsqueda por LSE" : "Glosa no disponible en la búsqueda por LSE. ¿Podría grabarnos un vídeo?" }
                </div> */}
                {/* {json_data_glosses[dialogPosition["gloss"]][pDataProvider.type] !== "" ? (
                  <>
                    <div className='sig_SignModal_PaperLine'>
                      <div className="sig_SignModal_PaperTitle sig_SignModal_Paper_Title_Body_Inline">Tipo:</div>
                      <div className="sig_SignModal_PaperBody">{json_data_glosses[dialogPosition["gloss"]][pDataProvider.type]}</div>
                    </div>
                  </>
                ) : (
                  <></>
                )} */}
              {/* </div>            */}
              {(sendFeedback2Server === undefined && currentUserRole !== pDB_user_roles.invitated && isAdmin !== true) ? (
                <>
                  <div className='sig_SignModal_PaperInfo'>
                    <div className='sig_SignModal_PaperLine'>
                      { json_data_glosses[dialogPosition["gloss"]][pDataProvider.model]===true ? "Signo disponible en la búsqueda por LSE" : "Signo no disponible en la búsqueda por LSE. ¿Podría grabarnos un vídeo?" }
                    </div>
                  </div>
                  <Button className="sig_SignDialog_Button sig_SignDialog_ButtonRecord" endIcon={<SendIcon />} onClick={handlePushScreenCollaborator}>
                    {dialogPosition["gloss"] !== undefined ? t("sDialog.recordSign").toUpperCase() : t("sDialog.recordNewVariant").toUpperCase()}
                  </Button>
                </>
              ) : 
              <></>
              }
            </Paper> 
          </>
        ) : (
          <>
            <Paper className="sig_SignModal_PaperContent">
              <div className='sig_SignModal_PaperInfo'>
                <div className='sig_SignModal_PaperLine'>
                  <div className="sig_SignModal_PaperTitle"> {t("sDialog.recordVariantText")} </div>
                  <div className="sig_SignModal_PaperBody"> {t("sDialog.recordVariantText2")} </div>
                </div>
              </div> 
              {(sendFeedback2Server === undefined && currentUserRole !== pDB_user_roles.invitated && isAdmin !== true) ? (
                <>
                  <Button className="sig_SignDialog_Button sig_SignDialog_ButtonRecord" endIcon={<SendIcon />} onClick={handlePushScreenCollaborator}>
                    {dialogPosition["gloss"] !== undefined ? t("sDialog.recordSign").toUpperCase() : t("sDialog.recordNewVariant").toUpperCase()}
                  </Button>
                </>
              ) : 
                <></>
              }
            </Paper>
          </>
        )}
        {props.children}
      </div>
    </>
  );
}
